<div class="app-bar">
  <div class="bar-content flex-row justify-around align-stretch">
    @for (barItem of state.barItems; track barItem) {
      <app-bar-item
        [svgIcon]='barItem.svgIcon'
        [routerLink]="barItem.routerLink && [barItem.routerLink]"
        (click)="barItem.onClick && barItem.onClick()"
        [badgeValue]="barItem.badgeValue$ | async"
        [badgeColor]="barItem.badgeColor"
        routerLinkActive="router-link-active">
      </app-bar-item>
    }

  </div>
</div>
